<template>
  <el-card>
    <div class="toolbar">
      <!-- <el-button type="primary" @click="onCreateItem()">
        <i class="fas fa-plus"></i> 新增授权码
      </el-button>-->
      <div class="former">
        <el-input
          v-model="Name"
          placeholder="授权码"
          style="width: 300px"
          @keydown.enter.native="onSubmitQuery"
        ></el-input
        >&nbsp;
        <select2
          v-model="form.BusinessTypeID"
          url="basic?type=BusinessType"
          placeholder="请选择业务类型"
          noDataText="无类型"
        ></select2
        >&nbsp;
        <select2
          v-model="form.SoftwareID"
          :url="softwareUrl"
          placeholder="请选择软件产品"
          noDataText="无产品"
        ></select2
        >&nbsp;
        <!-- <select2
          v-model="form.FunctionID"
          :url="functionUrl"
          placeholder="请选择功能版本"
          noDataText="无版本"
        ></select2
        >&nbsp; -->
        <select2
          labelName="NameNumber"
          v-model="form.ContractID"
          style="width: 300px"
          url="contract/list"
          clearable
          placeholder="选择合同"
          no-data-text="没有合同"
          :urlParams="urlContactParams"
          q="ContractNumber|Name:like"
          :qinwhere="true"
          :queryOne="false"
        ></select2
        >&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>
    <el-table :data="itemList" v-loading="loading" size="medium">
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * pager.page).toString().length * 12)"
      ></el-table-column>
      <el-table-column
        prop="BusinessType.Name"
        label="业务类型"
        width="85"
      ></el-table-column>
      <el-table-column label="软件产品" width="*">
        <template slot-scope="scope">
          <span v-if="scope.row.Software">{{ scope.row.Software.Name }}</span>
          <span v-if="scope.row.TargetVersion"
            >_{{ scope.row.TargetVersion }}</span
          >
          <span v-if="scope.row.Function">_{{ scope.row.Function.Name }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Name" label="授权码" width="300">
        <template slot-scope="{ row }">
          {{ formatStr(row.Name) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="Contract.ContractNumber"
        label="所属合同"
        width="180"
      >
        <template slot-scope="scope">
          <el-link type="primary" v-if="scope.row.Contract">
            <a
              target="_self"
              class="buttonText"
              @click="showContract(scope.row)"
              >{{ scope.row.Contract.Name }}</a
            >
          </el-link>
        </template>
      </el-table-column>
      <el-table-column prop="Station.Name" label="当前绑定站点" width="280"
        ><template slot-scope="scope">
          <el-link type="primary" v-if="scope.row.Station">
            <a
              target="_self"
              class="buttonText"
              @click="showStaton(scope.row)"
              >{{ scope.row.Station.Name }}</a
            >
          </el-link>
        </template>
      </el-table-column>
      <el-table-column label="硬件产品型号/SN" width="200" min-width="200">
        <template slot-scope="{ row }">
          <div v-if="row.IpcProduct && row.IpcProduct.IpcProductModel">
            {{ row.IpcProduct.IpcProductModel.Name }}
          </div>
          <div v-if="row.IpcProduct">
            <!-- <el-tag>{{ row.IpcProduct.SN }}</el-tag> -->
            <el-link type="primary">
              <a target="_self" class="buttonText" @click="showProduct(row)">{{
                row.IpcProduct.SN
              }}</a>
            </el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="60" label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            @click.stop="showRecord(scope.row)"
            title="使用记录"
          >
            <i class="fas fa-list"></i>
          </el-button>
          <!-- <el-button type="danger" @click.stop="onDeleteItem(scope.row)" title="删除">
            <i class="fas fa-trash-alt"></i>
          </el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      ></el-pagination>
    </div>
    <record v-model="item" :visible.sync="recordVisible" />
    <create-code
      v-model="item"
      :visible.sync="itemVisible"
      @form:saved="getItemList"
    />

    <el-dialog
      title="站点信息"
      :visible.sync="showVisible"
      @close="showVisible = false"
      width="80%"
      top="5%"
      append-to-body
      :close-on-click-modal="false"
      ><show-station :ID="statonID" :showBack="false" :key="statonID" />
    </el-dialog>

    <el-dialog
      title="合同信息"
      :visible.sync="contractVisible"
      @close="contractVisible = false"
      width="900px"
      top="5%"
      append-to-body
      :close-on-click-modal="false"
    >
      <table
        border="1"
        bordercolor="#dedede"
        style="width: 100%; border-collapse: collapse"
      >
        <tr>
          <th width="15%">合同编号</th>
          <td width="35%">{{ contract.ContractNumber }}</td>
          <th width="15%">合同名称</th>
          <td width="35%">{{ contract.Name }}</td>
        </tr>
        <tr>
          <th>所属客户</th>
          <td>
            <div v-if="contract.Client">{{ contract.Client.ClientName }}</div>
          </td>
          <th>合同签订日期</th>
          <td>
            <div v-if="contract.CheckDay">
              {{ contract.CheckDay.substring(0, 10) }}
            </div>
          </td>
        </tr>
        <tr>
          <th>合同开始日期</th>
          <td>
            <div v-if="contract.ContractStartDay">
              {{ contract.ContractStartDay.substring(0, 10) }}
            </div>
          </td>
          <th>合同结束日期</th>
          <td>
            <div v-if="contract.ContractEndDay">
              {{ contract.ContractEndDay.substring(0, 10) }}
            </div>
          </td>
        </tr>
        <tr>
          <th colspan="1">备注</th>
          <td colspan="3">{{ contract.Remark }}</td>
        </tr>
      </table>
    </el-dialog>

    <el-dialog
      title="硬件产品信息"
      :visible.sync="productVisible"
      @close="productVisible = false"
      width="60%"
      top="5%"
      append-to-body
      :close-on-click-modal="false"
      ><show-product :ID="productID" :showBack="false" :key="productID" />
    </el-dialog>
  </el-card>
</template>

<script>
import CreateCode from "./index--form.vue";
import Record from "./index--detail.vue";
import ShowStation from "../../pn/station/index--detail.vue";
import ShowProduct from "../../ipc/productInout/detail.vue";

export default {
  components: {
    CreateCode,
    Record,
    ShowStation,
    ShowProduct,
  },
  data() {
    return {
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 20,
      },
      Name: "",
      form: {
        "Name:like": "",
        SoftwareID: "",
        BusinessTypeID: "",
        FunctionID: "",
        ContractID: "",
      },
      item: this.getEmptyItem(),
      itemVisible: false,
      recordVisible: false,
      softwareUrl: "software",
      functionUrl: "basic?type=Function",
      showVisible: false,
      contractVisible: false,
      productVisible: false,
      statonID: "",
      productID:"",
      contract: {},
      urlContactParams: {
        where: {},
        BusinessGroups: "Ipc_BusinessGroup",
      },
    };
  },
  watch: {
    "form.BusinessTypeID": {
      handler() {
        this.softwareUrl = `software?where[BusinessTypeID]=${this.form.BusinessTypeID}`;
      },
    },
    // "form.SoftwareID": {
    //   handler() {
    //     this.functionUrl = `functionversion?software_id=${this.form.SoftwareID}`;
    //   },
    // },
  },
  mounted() {
    this.getItemList();
  },
  methods: {
    // 获取
    getItemList() {
      this.loading = true;
      this.$axios
        .get("ipccode", {
          params: {
            where: this.form,
            with: [
              "Software",
              "Station",
              "BindRecords/count",
              "BusinessType",
              "Function",
              "Contract",
            ],
            ...this.pager,
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 查询
    onSubmitQuery() {
      this.pager.page = 1;
      this.form["Name:like"] = this.Name.split("-").join("");
      this.getItemList();
    },
    // 翻页
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    formatStr(str) {
      let value = "";
      if (str) {
        for (let i = 0; i < 5; i++) {
          if (i === 0) {
            value = str.substring(0, 5);
          } else if (str.substring(i * 5, i * 5 + 5)) {
            value = `${value}-${str.substring(i * 5, i * 5 + 5)}`;
          }
        }
      }
      return value;
    },
    // 编辑
    showRecord(row) {
      this.item = row;
      this.recordVisible = true;
    },
    // 删除
    onDeleteItem(row) {
      this.$confirm("确定要删除该授权码吗？", "提示")
        .then(() => this.$axios.delete(`code/${row.ID}`))
        .then(() => {
          this.getItemList();
          this.$message.success("成功删除");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    // 新增
    onCreateItem() {
      this.item = this.getEmptyItem();
      this.itemVisible = true;
    },
    // item置空
    getEmptyItem() {
      return {};
    },
    showStaton(row) {
      this.statonID = row.Station.ID;
      this.showVisible = true;
    },
    // 打开合同详情
    showContract(row) {
      this.statonID = row.Station.ID;
      this.contractVisible = true;
      this.contract = row.Contract;
    },
    showProduct(row) {
      this.productID = row.IpcProduct.ID;
      this.productVisible = true;
    },
  },
};
</script>

<style scoped lang="scss">
table th td,
table tr td {
  padding: 2px 5px;
  height: 30px;
  line-height: 30px;
}
table th {
  text-align: center;
  padding-left: 5px;
  color: #646566;
  background-color: #ecf5ff;
}
</style>
